/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface CreateLootBoxConfigResponse
 */
export interface CreateLootBoxConfigResponse {
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof CreateLootBoxConfigResponse
     */
    lootBoxConfig: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the CreateLootBoxConfigResponse interface.
 */
export function instanceOfCreateLootBoxConfigResponse(value: object): value is CreateLootBoxConfigResponse {
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    return true;
}

export function CreateLootBoxConfigResponseFromJSON(json: any): CreateLootBoxConfigResponse {
    return CreateLootBoxConfigResponseFromJSONTyped(json, false);
}

export function CreateLootBoxConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLootBoxConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfig': LootBoxConfigResponseFromJSON(json['lootBoxConfig']),
    };
}

export function CreateLootBoxConfigResponseToJSON(json: any): CreateLootBoxConfigResponse {
    return CreateLootBoxConfigResponseToJSONTyped(json, false);
}

export function CreateLootBoxConfigResponseToJSONTyped(value?: CreateLootBoxConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfig': LootBoxConfigResponseToJSON(value['lootBoxConfig']),
    };
}

